var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-component loading-notice"},[_c('span',{staticClass:"loading"},[_c('LoadingIcon',{attrs:{"rotate":""}}),_vm._v(" Loading...")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }